<template>
    <div>
        <view1 ref="view1"></view1>
    </div>
</template>

<script>
import View1 from "./view1";
export default {
    components: { View1},
    props: {
        datasrow: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
        };
    },
    methods: {
        handleClick() {
            this.$refs.view1.getList(this.datasrow);
        },
        getList() {
            this.$emit("getList");
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-tabs__header {
    margin: 0 !important;
}
</style>
